import { render, staticRenderFns } from "./min-candies.vue?vue&type=template&id=197aefb0&scoped=true&"
import script from "./min-candies.vue?vue&type=script&lang=js&"
export * from "./min-candies.vue?vue&type=script&lang=js&"
import style0 from "./min-candies.vue?vue&type=style&index=0&id=197aefb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aefb0",
  null
  
)

export default component.exports